import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import { FontRoboto } from "../../../../styles/Theme";
import React from "react";

const useStyles = makeStyles((theme) => ({
  downloadCsv: {
    padding: "16px",
    backgroundColor: "transparent",
    borderRadius: "8px",
    color: theme.palette.text.secondary,
    fontWeight: 500,
    width: "183px",
    height: "45px",
    boxShadow: "none",
    fontSize: "16px",
    letterSpacing: "0.12px",
    textAlign: "left",
    fontFamily: FontRoboto,
    "&:hover": {
      backgroundColor: "#F2F2F2",
      width: "183px",
      height: "45px",
      textDecoration: "underline",
      color: theme.palette.text.primary,
      boxShadow: "none",
      transform: "none",
    },
    "& .MuiButton-startIcon > *:nth-of-type(1)": {
      fontSize: "1rem",
    },
  },
  downloadCsvHeader: {
    fontFamily: FontRoboto,
    fontWeight: 500,
    backgroundColor: "transparent",
    padding: "0px",
    color: "#fff",
    height: "21px",
    boxShadow: "none",
    fontSize: "16px",
    "&:hover": {
      textDecoration: "underline",
      backgroundColor: "transparent",
    },
    "& .MuiButton-startIcon > *:nth-of-type(1)": {
      fontSize: "1rem",
    },
  },
}));

interface DownloadCsvButtonProps {
  buttonText?: string;
  cssClass?: string;
  onClick: () => void;
}

export const DownloadCsvButton = (props: DownloadCsvButtonProps) => {
  const classes = useStyles();
  const { buttonText = "Download XLSX", cssClass, onClick } = props;
  const [hover, setHover] = React.useState(false);
  return (
    <Button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      size="medium"
      className={cssClass === "header" ? classes.downloadCsvHeader : classes.downloadCsv}
      variant="contained"
      sx={{ marginLeft: "-0.85em" }}
      startIcon={
        hover ? (
          <i className="fa-solid fa-download fa-fw"></i>
        ) : (
          <i className="fa-regular fa-download fa-fw"></i>
        )
      }>
      {buttonText}
    </Button>
  );
};
